import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetServiceLocationUrl = (locationId: string | undefined) => {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  if (!locationId) return ''

  switch (externalProduct) {
    case externalProductPestPacName:
      return `${clientUrl}/location/detail.asp?LocationID=${locationId}`
    default:
      return ''
  }
}
